<template>
  <v-card outlined v-if="bbrbbr.length !== 0" class="rounded-lg">
    <v-img :src="'/static/calendarEventImages/img_schankverlust_1x.jpg'" height="100px">
      <v-card-title class="white--text">Bierranking {{ $filters.date(date, "MM.YY") }}</v-card-title>
    </v-img>
    <v-card-text class="pa-0">
      <v-simple-table dense fixed-header class="rounded-lg">
        <tbody>
          <tr v-for="(item, index) in statistik" :key="item[0]" v-on:dblclick="(bbr = item) && (showBbr = true)">
            <td width="30px" v-if="index === 0"><v-icon class="amber--text lighten-1">emoji_events</v-icon></td>
            <td width="30px" v-if="index === 1"><v-icon class="grey--text lighten-1">emoji_events</v-icon></td>
            <td width="30px" v-if="index === 2"><v-icon class="deep-orange--text darken-3">emoji_events</v-icon></td>
            <td width="30px" v-if="index > 2"><v-icon>military_tech</v-icon></td>
            <td>{{ $filters.user(item[0], bbrbbr) }}</td>
            <td>{{ item[1] }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    data() {
      return {
        date: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().substr(0, 7),
        menu: false,
        max: new Date(0).toISOString().substr(0, 7),
        min: new Date().toISOString().substr(0, 7),
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      nurbbrbbr() {
        return this.$store.getters["bbrbbr/nurBbrbbr"];
      },
      statistiken() {
        if (this.$store.state.statistiken.statistiken.length === 0) {
          this.$store.dispatch("statistiken/loadStatistiken");
        }
        this.$store.state.statistiken.statistiken.forEach((item) => {
          if (new Date(item.monat).toISOString().substr(0, 7) < this.min) {
            this.min = new Date(item.monat).toISOString().substr(0, 7);
          }
          if (new Date(item.monat).toISOString().substr(0, 7) > this.max) {
            this.max = new Date(item.monat).toISOString().substr(0, 7);
          }
        });
        return this.$store.state.statistiken.statistiken;
      },
      statistik() {
        let monat = this.date;
        let selectStatistik = this.statistiken.find((statistik) => statistik.monat === monat);
        let stricheProBbrSortiert = [];
        if (selectStatistik !== undefined) {
          for (var item in selectStatistik.stricheProBbr) {
            let bbr = this.$store.getters["bbrbbr/bbr"](item);
            if (bbr.status !== "Chargen & Ämter") {
              stricheProBbrSortiert.push([item, selectStatistik.stricheProBbr[item]]);
            }
          }
          if (stricheProBbrSortiert.length > 0) {
            stricheProBbrSortiert.sort(function (a, b) {
              return b[1] - a[1];
            });
            stricheProBbrSortiert = stricheProBbrSortiert.slice(0, 5);
          }
        }
        return stricheProBbrSortiert;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// bierranking.vue?78bb5b86